import { type PerformanceCondition } from '@strata/react-performance';
import { SuccessToast } from '@strata/react-toast-message';

import { getPerformanceByReferralId, savePerformanceConditions } from 'api/performanceAPI';
import { handleError } from 'services/Error';
import { type AppThunk } from 'store';
import { setPerformanceItemsForReferral } from 'store/wonReferrals/performanceSlice';
import { fetchWorklistTasks } from 'store/worklist/worklistThunks';

export const fetchPerformanceEntries =
    (referralId: string): AppThunk =>
    async (dispatch, getState) => {
        try {
            // Fetch all pieces of data needed for referrals
            const performanceItems = await getPerformanceByReferralId({
                npi: getState().auth.selectedNpi!,
                referralId,
            });
            if (performanceItems.length > 0) {
                dispatch(
                    setPerformanceItemsForReferral({
                        referralId: performanceItems[0].referral_id,
                        performanceItems,
                    }),
                );
            }
        } catch (err) {
            handleError('An error occurred retrieving performance information.', err as Error);
        }
    };

export const submitPerformanceConditions =
    (
        referralId: string,
        conditions: PerformanceCondition[],
        onSubmitSuccess?: () => void,
    ): AppThunk =>
    async (dispatch, getState) => {
        try {
            const performanceItems = await savePerformanceConditions({
                npi: getState().auth.selectedNpi!,
                referralId,
                conditions,
            });
            SuccessToast({ message: 'Documentation saved.' });

            dispatch(
                setPerformanceItemsForReferral({
                    referralId,
                    performanceItems,
                }),
            );

            // Update worklist tasks in store
            await dispatch(fetchWorklistTasks());

            onSubmitSuccess?.();
        } catch (err) {
            handleError('An error occurred submitting documentation.', err as Error);
        }
    };
